/* EMI fallback nudge (product pages).
   If a buyer opens the Snapmint "Buy On EMI" (Budli Pay Later) modal and closes it
   without proceeding — abandoned OR credit-declined (approval is Snapmint's call) —
   gently surface the alternative payment paths so they don't leave: pay in full via
   UPI/Cards, or COD. Detects the modal (#snap-modalon_page) by presence; it's fully
   added on open and removed on close. If EMI completes, Snapmint redirects to
   checkout (page unloads) so the nudge never shows on success. No deps. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var MODAL_ID = 'snap-modalon_page';
  var CAP_KEY = 'budli_emi_nudge_count';
  var MAX = 3; // soft cap per session
  var wasOpen = false, visible = false;

  var css = document.createElement('style');
  css.textContent =
    '#budli-emi-fallback{position:fixed;left:12px;right:12px;top:80px;z-index:100000;display:flex;justify-content:center;pointer-events:none}'
  + '#budli-emi-fallback .bemi-in{pointer-events:auto;max-width:540px;width:100%;display:flex;align-items:center;gap:10px;background:#101820;color:#fff;border-radius:12px;padding:11px 14px;box-shadow:0 10px 30px rgba(0,0,0,.25);font-size:13.5px;line-height:1.35;animation:bemiIn .25s ease}'
  + '#budli-emi-fallback.bemi-out .bemi-in{opacity:0;transition:opacity .35s}'
  + '#budli-emi-fallback .bemi-txt{flex:1}'
  + '#budli-emi-fallback strong{color:#9ae6b4;font-weight:700}'
  + '#budli-emi-fallback .bemi-cta{flex:none;background:#f1592a;color:#fff;border:0;border-radius:8px;padding:8px 12px;font-weight:700;font-size:13px;cursor:pointer;white-space:nowrap}'
  + '#budli-emi-fallback .bemi-x{flex:none;background:transparent;border:0;color:#9aa3ad;font-size:20px;line-height:1;cursor:pointer;padding:0 2px}'
  + '@keyframes bemiIn{from{transform:translateY(-12px);opacity:0}to{transform:none;opacity:1}}'
  + '.bemi-pulse{animation:bemiPulse .8s ease 2}'
  + '@keyframes bemiPulse{50%{box-shadow:0 0 0 6px rgba(241,89,42,.4)}}'
  + '@media(max-width:600px){#budli-emi-fallback{top:72px}#budli-emi-fallback .bemi-in{font-size:12.5px;padding:10px 12px;gap:8px}#budli-emi-fallback .bemi-cta{padding:7px 10px;font-size:12px}}';
  document.head.appendChild(css);

  function count() { try { return parseInt(sessionStorage.getItem(CAP_KEY) || '0', 10); } catch (e) { return 0; } }

  // Breeze checkout needs a real (trusted) tap, so a script can't auto-open it.
  // Instead, add this product and open the cart drawer — which surfaces the
  // prominent BUY NOW (one trusted tap → Breeze) plus COD. cart-sync auto-opens
  // the drawer on add; we add a fallback open in case it doesn't.
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && (drawer.classList.contains('active') || drawer.classList.contains('animate'))) return;
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon) icon.click();
    else if (drawer) { drawer.classList.add('active', 'animate'); document.body.classList.add('overflow-hidden'); }
  }
  function triggerBuyNow() {
    var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
    var vid = idEl && idEl.value;
    if (!vid) { openDrawer(); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function () { setTimeout(openDrawer, 450); }).catch(function () { openDrawer(); });
  }

  function showNudge() {
    if (visible || count() >= MAX) return;
    visible = true;
    try { sessionStorage.setItem(CAP_KEY, count() + 1); } catch (e) {}
    var b = document.createElement('div');
    b.id = 'budli-emi-fallback';
    b.innerHTML = '<div class="bemi-in">'
      + '<span class="bemi-txt">EMI not completed? You can still <strong>pay in full</strong> (UPI/Cards) or choose <strong>COD</strong>.</span>'
      + '<button type="button" class="bemi-cta">Pay now →</button>'
      + '<button type="button" class="bemi-x" aria-label="Dismiss">×</button>'
      + '</div>';
    document.body.appendChild(b);
    function close() { if (b.parentNode) b.parentNode.removeChild(b); visible = false; }
    b.querySelector('.bemi-cta').addEventListener('click', function () {
      close();
      triggerBuyNow();
    });
    b.querySelector('.bemi-x').addEventListener('click', close);
    setTimeout(function () { if (b.parentNode) { b.classList.add('bemi-out'); setTimeout(close, 400); } }, 11000);
  }

  setInterval(function () {
    var open = !!document.getElementById(MODAL_ID);
    if (open) { wasOpen = true; }
    else if (wasOpen) {
      wasOpen = false;
      if (/\/products\//.test(location.pathname)) {
        setTimeout(function () { if (!document.getElementById(MODAL_ID)) showNudge(); }, 700);
      }
    }
  }, 400);
})();
